<section class="user-properties-list">
    <main>
        <sp-modal title="REMOVE THIS PROPERTY" (confirm)="onArchive()" confirmButtonText="Remove" isWarning="true">
            This action will remove the property from your workspace. Users will no longer be able to access the property or it's components.
        </sp-modal>

        <div class="row">
            <div class="col-md-12">

                <sp-no-results-found *ngIf="!hasResults()" [message]="'No properties found'"></sp-no-results-found>

                <ng-container *ngIf="hasResults()">
                    <div class="row grid-header" *ngIf="userProfile?.workspaceCount > 1">
                        <div class="col-md-5 text-start text-uppercase">Property Name</div>
                        <div class="col-md-2 text-start text-uppercase">Property Type</div>
                        <div class="col-md-2 text-start text-uppercase">Location</div>
                        <div class="col-md-3 text-start text-uppercase">Portfolio</div>
                    </div>
                    <div class="row grid-header" *ngIf="userProfile?.workspaceCount <= 1">
                        <div class="col-md-5 text-start text-uppercase">Property Name</div>
                        <div class="col-md-3 text-start text-uppercase">Property Type</div>
                        <div class="col-md-4 text-start text-uppercase">Location</div>
                    </div>

                    <ng-container *ngFor="let property of propertySearchResult?.propertiesPaged?.data">
                        <div class="row grid-row font-size-small" *ngIf="userProfile?.workspaceCount > 1">
                            <div class="col-md-5 property-link" (click)="onViewDashboard(property)"><span title="{{property.propertyName}}">{{ property.propertyName }}</span></div>
                            <div class="col-md-2"><span title="{{property.propertyTypeName}}">{{property.propertyTypeName}}</span></div>
                            <div class="col-md-2"><span title="{{property.propertyCity}}, {{ property.propertyState }}">{{ property.propertyCity }}, {{ property.propertyState }}</span></div>
                            <div class="col-md-2"><span title="{{property.workspaceCompanyName}}">{{property.workspaceCompanyName}}</span></div>
                            <div class="col-md-1 text-end" *ngIf="property.roleName === 'Admin' || property.roleName === 'Manager' || property.roleName === 'PortfolioAdmin'">
                                <span class="sp-icon-edit-30 vertical-center edit-btn" (click)="onEditDetails(property)"></span>
                                <span class="sp-icon-delete u-alignMiddle" (click)="delete(property)"></span>
                            </div>
                        </div>
                        <div class="row grid-row font-size-small" *ngIf="userProfile?.workspaceCount <= 1">
                            <div class="col-md-5 property-link" (click)="onViewDashboard(property)"><span title="{{property.propertyName}}">{{ property.propertyName }}</span></div>
                            <div class="col-md-3"><span title="{{property.propertyTypeName}}">{{property.propertyTypeName}}</span></div>
                            <div class="col-md-3"><span title="{{property.propertyCity}}, {{ property.propertyState }}">{{ property.propertyCity }}, {{ property.propertyState }}</span></div>
                            <div class="col-md-1 text-end" *ngIf="property.roleName === 'Admin' || property.roleName === 'Manager' || property.roleName === 'PortfolioAdmin'">
                                <span class="sp-icon-edit-30 vertical-center edit-btn" (click)="onEditDetails(property)"></span>
                                <span class="sp-icon-delete u-alignMiddle" (click)="delete(property)"></span>
                            </div>
                        </div>
                    </ng-container>

                    <br />                    
                    
                    <dx-pagination
                        [itemCount]="propertySearchResult?.page?.totalItems || 0"
                        [pageSize]="20"
                        [showPageSizeSelector]="false"
                        [showInfo]="true"
                        [showNavigationButtons]="true"
                        (onOptionChanged)="onDxPageChanged($event)">
                    </dx-pagination>
                </ng-container>
            </div>
        </div>
    </main>
</section>
